import React from 'react';
import Navbar from '../Components/Navbar';
import VehicleShowcase from '../Components/VehicleShowcase';
import Footer from '../Components/Footer';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Shield, Clock, Car, ArrowRight, Phone } from 'lucide-react';
import './Vehicles.css';

const Vehicles = () => {
  const highlights = [
    { icon: <Shield size={20} />, label: 'Full Kasko', value: 'Tüm Araçlarda' },
    { icon: <Car size={20} />, label: 'Modern Filo', value: '2023+ Modeller' },
    { icon: <Clock size={20} />, label: 'Destek', value: '7/24 Kesintisiz' },
  ];

  return (
    <div style={{ backgroundColor: 'var(--bg-main)', minHeight: '100vh', position: 'relative', overflow: 'hidden' }}>
      <Navbar />

      {/* Ambient Lights */}
      <div className="ambient-light" style={{ top: '-10%', right: '-10%', opacity: 0.15 }}></div>
      <div className="ambient-light ambient-light-silver" style={{ bottom: '-15%', left: '-10%', opacity: 0.08 }}></div>
      
      <main style={{ paddingTop: '160px' }}>
        {/* Hero Header */}
        <section className="vehicles-hero">
          <div className="container">
            <div className="vehicles-hero-grid">
              <motion.div 
                className="vehicles-hero-content"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: [0.23, 1, 0.32, 1] }}
              >
                <div className="vehicles-badge">Araç Kataloğu</div>
                <h1 className="section-title">Araç<span>Koleksiyonumuz.</span></h1>
                <p className="vehicles-hero-desc">
                  Prestij, güven ve performansın buluştuğu seçkin koleksiyonumuz. 
                  2023 ve üzeri model araçlarımızla her sürüşte ayrıcalığı hissedin.
                </p>

                {/* Highlight Stats */}
                <div className="vehicles-highlights">
                  {highlights.map((item, i) => (
                    <motion.div
                      key={i}
                      className="vehicles-highlight-item"
                      initial={{ opacity: 0, y: 15 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.4 + i * 0.1 }}
                    >
                      <div className="vehicles-highlight-icon">{item.icon}</div>
                      <div>
                        <div className="vehicles-highlight-label">{item.label}</div>
                        <div className="vehicles-highlight-value">{item.value}</div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* Hero Featured Car */}
              <motion.div
                className="vehicles-hero-image"
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3, duration: 1 }}
              >
                <img src="/images/bmw_main.png" alt="BMW 520i" />
                <div className="vehicles-hero-image-glow"></div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Vehicle Showcase */}
        <VehicleShowcase />

        {/* CTA Section */}
        <section className="vehicles-cta">
          <div className="container">
            <motion.div
              className="vehicles-cta-content"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="vehicles-cta-title">
                Aradığınız Aracı<br/>
                <span>Bulamadınız mı?</span>
              </h2>
              <p className="vehicles-cta-desc">
                Portföyümüzde olmayan araçlar için bize ulaşın. 
                İhtiyacınıza özel çözümler üretelim.
              </p>
              <div className="vehicles-cta-actions">
                <Link to="/teklif-al" className="vehicles-cta-btn-primary">
                  <span>Teklif Alın</span>
                  <ArrowRight size={18} />
                </Link>
                <a href="tel:+905321585646" className="vehicles-cta-btn-phone">
                  <Phone size={18} />
                  <span>0532 158 56 46</span>
                </a>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Vehicles;
